import React from 'react';
import { DismissableLayerBranch } from '@radix-ui/react-dismissable-layer';
import { DROPDOWN_PORTAL_ATTR, stopModalScrollLockPropagation } from './dropdownPortal';

/**
 * Portaled dropdown panel wrapper. Radix Dialog sets `pointer-events: none` on `document.body`;
 * branch + explicit pointer-events keeps option lists clickable inside modals.
 */
export default function DropdownSearchPortalLayer({ style, children }: {
  style?: React.CSSProperties;
  children: React.ReactNode;
}) {
  return (
    <DismissableLayerBranch
      {...{ [DROPDOWN_PORTAL_ATTR]: '' }}
      style={{ ...style, pointerEvents: 'auto' }}
      onWheel={stopModalScrollLockPropagation}
      onTouchMove={stopModalScrollLockPropagation}
    >
      {children}
    </DismissableLayerBranch>
  );
}
